import { Element } from "./element.js";
import { Slot } from "./slot.js";
import { Text } from "./text.js";
/**
 * @public
 */
export var Slotable;
(function (Slotable) {
    function isSlotable(value) {
        return Element.isElement(value) || Text.isText(value);
    }
    Slotable.isSlotable = isSlotable;
    /**
     * {@link https://dom.spec.whatwg.org/#slotable-name}
     */
    function name(slotable) {
        return Element.isElement(slotable)
            ? slotable
                .attribute("slot")
                .map((slot) => slot.value)
                .getOr("")
            : "";
    }
    Slotable.name = name;
    /**
     * {@link https://dom.spec.whatwg.org/#find-a-slot}
     */
    function findSlot(slotable) {
        const name = Slotable.name(slotable);
        return slotable
            .parent()
            .filter(Element.isElement)
            .flatMap((parent) => parent.shadow.flatMap((shadow) => shadow
            .descendants()
            .filter(Slot.isSlot)
            .find((slot) => Slot.name(slot) === name)));
    }
    Slotable.findSlot = findSlot;
})(Slotable || (Slotable = {}));
//# sourceMappingURL=slotable.js.map